import React from 'react';
import { FiShoppingBag } from 'react-icons/fi';

// Substitua ou amplie esta lista quando os logos definitivos estiverem disponíveis.
// Para usar uma imagem, adicione: logo: '/logos/nome-do-arquivo.jpg'.
const establishments = [
  { name: 'Hashi & Panela', logo: '/logos/hashi.jpg' },
  { name: 'S.A Casa de Sushi Maringá', logo: '/logos/samaringa.jpg', roundLogo: true },
  { name: 'Tsuki Go', logo: '/logos/tsuki.jpg' },
];

const EstablishmentCard = ({ establishment }) => (
  <figure className="trusted-establishment-card">
    <div className="trusted-establishment-icon" aria-hidden="true">
      {establishment.logo ? (
        <img
          src={establishment.logo}
          alt=""
          className={`h-full w-full object-cover ${
            establishment.roundLogo ? 'rounded-full' : 'rounded-xl'
          }`}
        />
      ) : (
        <FiShoppingBag className="h-7 w-7" />
      )}
    </div>
    <figcaption className="whitespace-nowrap text-base font-semibold tracking-tight text-white sm:text-lg">
      {establishment.name}
    </figcaption>
  </figure>
);

const MarqueeRow = ({ items }) => (
  <div className="trusted-marquee">
    {[0, 1].map((copy) => (
      <div key={copy} className="trusted-marquee-group" aria-hidden={copy === 1}>
        {items.map((establishment) => (
          <EstablishmentCard
            key={`${copy}-${establishment.name}`}
            establishment={establishment}
          />
        ))}
      </div>
    ))}
  </div>
);

const TrustedEstablishmentsMarquee = () => {
  return (
    <div className="trusted-marquee-shell" aria-label="Estabelecimentos que confiam na AyTech">
      <MarqueeRow items={establishments} />
    </div>
  );
};

export default TrustedEstablishmentsMarquee;
